import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {get} from 'lodash';
import Contributors from './contributors';
import UpdatedDate from './updated_date';
import SocialIcons from '../common/social_icons';
import BrandingBanner from '../common/branding_banner';
import { StaticAssets } from '../common/static_assets';
import { defineMessages, injectIntl } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';

const i18nMessages = decorateIntlMessages(
  __filename,
  defineMessages({
    squigglyLine: {
      id: 'squigglyLine',
      description: 'Translation for Squiggly Line alt text',
      defaultMessage: 'Squiggly Line'
    }
  })
);

export class ArticleHeader extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.published !== this.props.published;
  }

  brandingBanner = (image_src) => (
    <BrandingBanner
      type="campaign"
      src={image_src}
      impressionTracker={this.props.campaign_branding_impressiontracker}
      clickTracker={this.props.campaign_branding_clicktracker}
      noFollow={this.props.campaign_branding_nofollow}
      alt_title={get(this.props.campaign_branding, 'alt_title')}
    />
  );

  programBrandingImage = (image_src) => (
    <BrandingBanner
      type="program"
      src={image_src}
      impressionTracker={this.props.program_branding_impression_tracker}
      clickTracker={this.props.program_branding_click_tracker}
      noFollow={this.props.program_branding_nofollow}
      alt_title={get(this.props.program_branding, 'alt_title')}
    />
  );

  render() {
    const {
      title,
      campaign_branding,
      campaign_branding_image_mobile_url,
      program_branding,
      program_branding_image_url,
      socialIconProps,
      bylines,
      original_published,
      published,
      dek,
      shouldDisplayDek,
      intl
    } = this.props;

    const campaign_src = get(
      campaign_branding,
      'image_src',
      campaign_branding_image_mobile_url
    );
    const program_src = get(
      program_branding,
      'image_src',
      program_branding_image_url
    );

    return (
      <div className="header">
        {campaign_src && this.brandingBanner(campaign_src)}
        {program_src && this.programBrandingImage(program_src)}
        <h1 className="title" dangerouslySetInnerHTML={{ __html: title }} />

        {shouldDisplayDek && (
          <p className="dek" dangerouslySetInnerHTML={{ __html: dek }} />
        )}
        <div className="bylines-container">
          <Contributors contributors={bylines} />
          <UpdatedDate
            original_published={original_published}
            published={published}
          />
        </div>
        {!shouldDisplayDek && (
          <SocialIcons
            {...socialIconProps}
            icons={['facebook', 'pinterest', 'email']}
          />
        )}

        {shouldDisplayDek && (
          <img
            src={StaticAssets.squigglyLine}
            className="squiggly-line"
            alt={intl.formatMessage(i18nMessages.squigglyLine)}
          />
        )}
      </div>
    );
  }
}

ArticleHeader.propTypes = {
  original_published: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  published: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  campaign_branding: PropTypes.object,
  campaign_branding_image_mobile_url: PropTypes.string,
  campaign_branding_clicktracker: PropTypes.string,
  campaign_branding_impressiontracker: PropTypes.string,
  campaign_branding_nofollow: PropTypes.bool,
  program_branding: PropTypes.object,
  program_branding_image_url: PropTypes.string,
  program_branding_click_tracker: PropTypes.string,
  program_branding_impression_tracker: PropTypes.string,
  program_branding_nofollow: PropTypes.bool,
  socialIconProps: PropTypes.object.isRequired,
  bylines: PropTypes.arrayOf(PropTypes.object.isRequired),
  dek: PropTypes.string,
  shouldDisplayDek: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  })
};

export default injectIntl(ArticleHeader);
